import { AmplifyGet } from '@sunrun/sales-experience-shared/amplify-api-wrapper';
import { useEffect, useState } from 'react';
import { useHybridToken } from './Auth';
import { logger } from './logger';

type CapResponse = { id: string };

const useCap = (
  prospectId: string,
  shouldFetch: boolean = true,
): { projectId: string; isLoading: boolean } => {
  const { hybridToken } = useHybridToken();
  const [projectId, setProjectId] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!prospectId || !hybridToken || !shouldFetch) {
      setProjectId('');
      return;
    }
    setIsLoading(true);
    setProjectId('');
    AmplifyGet<CapResponse>(
      'Get Cap',
      'SalesExpDashboardApi',
      `/cap/${prospectId}`,
      {
        headers: {
          Authorization: `Bearer ${hybridToken}`,
        },
      },
      logger,
      {
        expectedErrorCodes: [401, 403],
      },
    )
      .then((data) => {
        if (data?.id) setProjectId(data.id);
      })
      .catch(() => {
        setProjectId('');
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [prospectId, hybridToken, shouldFetch]);

  return { projectId, isLoading };
};

export { useCap };
